import request from "@/utils/request";

/**
 * 帖子收藏相关 API
 */

/**
 * 收藏帖子
 * @param {number} postId 帖子ID
 * @returns {Promise}
 */
export function favoritePost(postId) {
  return request.post(`/api/post/favorite/${postId}`);
}

/**
 * 取消收藏
 * @param {number} postId 帖子ID
 * @returns {Promise}
 */
export function unfavoritePost(postId) {
  return request.delete(`/api/post/favorite/${postId}`);
}

/**
 * 当前用户收藏的帖子分页
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页数量
 * @returns {Promise}
 */
export function getFavoritePageCurrentUser(pageNum = 1, pageSize = 10) {
  return request.get("/api/post/favorite/page/currentUser", {
    params: {
      pageNum,
      pageSize,
    },
  });
}
